/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Box, Group, rem, useMantineTheme } from '@mantine/core';
import type React from 'react';

export function DetailHeader({
  children,
  constants,
}: {
  children: React.ReactNode;
  constants: {
    portalZIndex: number;
    subHeaderHeight: number;
  };
}) {
  const theme = useMantineTheme();
  const { portalZIndex, subHeaderHeight } = constants;

  return (
    <Box
      pos="sticky"
      style={{
        zIndex: portalZIndex - 1,
      }}
      top={0}
    >
      <Group
        align="center"
        bg={theme.pf.color.fg.white}
        h={subHeaderHeight}
        justify="space-between"
        pr={theme.pf.layout.md}
        style={{
          borderBottom: `${rem(1)} solid ${theme.pf.color.border.neutral.default}`,
          overflowX: 'auto',
        }}
        wrap="nowrap"
      >
        {children}
      </Group>
    </Box>
  );
}
